export default __webpack_public_path__ + "static/media/avatarStub.d4f67f89.svg";